export const hasDisabledSharing = mode => (mode ? mode === 'disabled' : true);
